import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FiArrowRightCircle } from 'react-icons/fi'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { Content } from './styles'
import Container from '../../components/Container'

const BemVindo: React.FC = () => {
  const history = useHistory()

  const handleStart = useCallback(async () => {
    history.push('/contribution')
  }, [history])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Olá, você é colaborador?</strong>
          <span>
            Então comece agora mesmo a planejar o seu futuro fazendo sua adesão
            ao Plano de Previdência Privada.
          </span>
          <Button color="blue" onClick={handleStart} width="large">
            Simule aqui sua adesão!
            <FiArrowRightCircle size={45} />
          </Button>
          <small>
            O Plano Aspprev Patrocinado é um plano de previdência oferecido a
            todos os colaboradores! O funcionário contribui com uma parte e a
            empresa com o mesmo valor, limitado as regras regulamentares. O
            objetivo principal é formar reserva de poupança e garantir maior
            segurança financeira para o seu futuro! Um complemento de renda aos
            valores que serão recebidos pelo INSS.
          </small>
        </Content>
      </Container>
    </>
  )
}

export default BemVindo
